// package.json
var $0dea53fbf8dad186$var$name = "@vercel/analytics";
var $0dea53fbf8dad186$var$version = "1.6.1";
// src/queue.ts
var $0dea53fbf8dad186$var$initQueue = ()=>{
    if (window.va) return;
    window.va = function a(...params) {
        (window.vaq = window.vaq || []).push(params);
    };
};
// src/utils.ts
function $0dea53fbf8dad186$var$isBrowser() {
    return typeof window !== "undefined";
}
function $0dea53fbf8dad186$var$detectEnvironment() {
    try {
        const env = "production";
        if (env === "development" || env === "test") return "development";
    } catch (e) {}
    return "production";
}
function $0dea53fbf8dad186$var$setMode(mode = "auto") {
    if (mode === "auto") {
        window.vam = $0dea53fbf8dad186$var$detectEnvironment();
        return;
    }
    window.vam = mode;
}
function $0dea53fbf8dad186$var$getMode() {
    const mode = $0dea53fbf8dad186$var$isBrowser() ? window.vam : $0dea53fbf8dad186$var$detectEnvironment();
    return mode || "production";
}
function $0dea53fbf8dad186$var$isProduction() {
    return $0dea53fbf8dad186$var$getMode() === "production";
}
function $0dea53fbf8dad186$var$isDevelopment() {
    return $0dea53fbf8dad186$var$getMode() === "development";
}
function $0dea53fbf8dad186$var$removeKey(key, { [key]: _, ...rest }) {
    return rest;
}
function $0dea53fbf8dad186$var$parseProperties(properties, options) {
    if (!properties) return void 0;
    let props = properties;
    const errorProperties = [];
    for (const [key, value] of Object.entries(properties))if (typeof value === "object" && value !== null) {
        if (options.strip) props = $0dea53fbf8dad186$var$removeKey(key, props);
        else errorProperties.push(key);
    }
    if (errorProperties.length > 0 && !options.strip) throw Error(`The following properties are not valid: ${errorProperties.join(", ")}. Only strings, numbers, booleans, and null are allowed.`);
    return props;
}
function $0dea53fbf8dad186$export$c689ba62f1421710(pathname, pathParams) {
    if (!pathname || !pathParams) return pathname;
    let result = pathname;
    try {
        const entries = Object.entries(pathParams);
        for (const [key, value] of entries)if (!Array.isArray(value)) {
            const matcher = $0dea53fbf8dad186$var$turnValueToRegExp(value);
            if (matcher.test(result)) result = result.replace(matcher, `/[${key}]`);
        }
        for (const [key, value] of entries)if (Array.isArray(value)) {
            const matcher = $0dea53fbf8dad186$var$turnValueToRegExp(value.join("/"));
            if (matcher.test(result)) result = result.replace(matcher, `/[...${key}]`);
        }
        return result;
    } catch (e) {
        return pathname;
    }
}
function $0dea53fbf8dad186$var$turnValueToRegExp(value) {
    return new RegExp(`/${$0dea53fbf8dad186$var$escapeRegExp(value)}(?=[/?#]|$)`);
}
function $0dea53fbf8dad186$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $0dea53fbf8dad186$var$getScriptSrc(props) {
    if (props.scriptSrc) return props.scriptSrc;
    if ($0dea53fbf8dad186$var$isDevelopment()) return "https://va.vercel-scripts.com/v1/script.debug.js";
    if (props.basePath) return `${props.basePath}/insights/script.js`;
    return "/_vercel/insights/script.js";
}
// src/generic.ts
function $0dea53fbf8dad186$export$a976684a0efeb93f(props = {
    debug: true
}) {
    var _a;
    if (!$0dea53fbf8dad186$var$isBrowser()) return;
    $0dea53fbf8dad186$var$setMode(props.mode);
    $0dea53fbf8dad186$var$initQueue();
    if (props.beforeSend) (_a = window.va) == null || _a.call(window, "beforeSend", props.beforeSend);
    const src = $0dea53fbf8dad186$var$getScriptSrc(props);
    if (document.head.querySelector(`script[src*="${src}"]`)) return;
    const script = document.createElement("script");
    script.src = src;
    script.defer = true;
    script.dataset.sdkn = $0dea53fbf8dad186$var$name + (props.framework ? `/${props.framework}` : "");
    script.dataset.sdkv = $0dea53fbf8dad186$var$version;
    if (props.disableAutoTrack) script.dataset.disableAutoTrack = "1";
    if (props.endpoint) script.dataset.endpoint = props.endpoint;
    else if (props.basePath) script.dataset.endpoint = `${props.basePath}/insights`;
    if (props.dsn) script.dataset.dsn = props.dsn;
    script.onerror = ()=>{
        const errorMessage = $0dea53fbf8dad186$var$isDevelopment() ? "Please check if any ad blockers are enabled and try again." : "Be sure to enable Web Analytics for your project and deploy again. See https://vercel.com/docs/analytics/quickstart for more information.";
        console.log(`[Vercel Web Analytics] Failed to load script from ${src}. ${errorMessage}`);
    };
    if ($0dea53fbf8dad186$var$isDevelopment() && props.debug === false) script.dataset.debug = "false";
    document.head.appendChild(script);
}
function $0dea53fbf8dad186$export$6b2a7d5132615086(name2, properties, options) {
    var _a, _b;
    if (!$0dea53fbf8dad186$var$isBrowser()) {
        const msg = "[Vercel Web Analytics] Please import `track` from `@vercel/analytics/server` when using this function in a server environment";
        if ($0dea53fbf8dad186$var$isProduction()) console.warn(msg);
        else throw new Error(msg);
        return;
    }
    if (!properties) {
        (_a = window.va) == null || _a.call(window, "event", {
            name: name2,
            options: options
        });
        return;
    }
    try {
        const props = $0dea53fbf8dad186$var$parseProperties(properties, {
            strip: $0dea53fbf8dad186$var$isProduction()
        });
        (_b = window.va) == null || _b.call(window, "event", {
            name: name2,
            data: props,
            options: options
        });
    } catch (err) {
        if (err instanceof Error && $0dea53fbf8dad186$var$isDevelopment()) console.error(err);
    }
}
function $0dea53fbf8dad186$export$b81f1580747d8b3a({ route: route, path: path }) {
    var _a;
    (_a = window.va) == null || _a.call(window, "pageview", {
        route: route,
        path: path
    });
}
var $0dea53fbf8dad186$export$2e2bcd8739ae039 = {
    inject: $0dea53fbf8dad186$export$a976684a0efeb93f,
    track: $0dea53fbf8dad186$export$6b2a7d5132615086,
    computeRoute: $0dea53fbf8dad186$export$c689ba62f1421710
};


(0, $0dea53fbf8dad186$export$a976684a0efeb93f)();


//# sourceMappingURL=path0.9950a74d.js.map
